import { defineMessages } from 'react-intl';

export const messages: {
	solutionBuildErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	solutionBuildErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	solutionBuildErrorTitle: {
		id: 'ai-mate.conversation-assistant-message-actions.studio-trigger-solution-build.plan-card.card-footer.action-button.solution-build-error-title',
		defaultMessage: 'Error',
		description: 'Error title for solution build error',
	},
	solutionBuildErrorDescription: {
		id: 'ai-mate.conversation-assistant-message-actions.studio-trigger-solution-build.plan-card.card-footer.action-button.solution-build-error-description',
		defaultMessage: 'Failed to trigger solution build',
		description: 'Error description for solution build error',
	},
});
